import React from "react";
import CardTop from "./CardTop";
import CardBottom from "./CardBottom";
import CardLeft from "./CardLeft";
import CardRight from "./CardRight";
import "./DownCards.scss";
function DownCards({ twoVstwo }) {
  return (
    <div className="downcards">
      <CardTop />
      {twoVstwo ? (
        <div>
          <CardRight />
          <CardLeft />
        </div>
      ) : (
        ""
      )}
      <CardBottom />
    </div>
  );
}

export default DownCards;
